import { ChevronLeft } from 'lucide-react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

const BackButtonHeader = ({ page }: { page: string }) => {
  const navigate = useNavigate()

  const buttonClick = () => {
    navigate(-1)
  }

  return (
    <div className="d-flex justify-content-start align-items-center gap-3 mb-4">
      <Button
        variant=""
        onClick={buttonClick}
        className="d-inline-flex shadow-sm justify-content-center align-items-center bg-white rounded-circle p-1 border-0">
        <ChevronLeft className="pe-1" size={34} color="black" strokeWidth="1.7" />
      </Button>
      <h3 className="fw-bold mb-0">{page}</h3>
    </div>
  )
}

export default BackButtonHeader